import { ErrorType } from "@/types";

export class CustomError extends Error {
  public type: ErrorType;
  constructor(type: ErrorType) {
    super();
    this.type = type;
  }
}
